import type { PlanEducationIconId } from './planEducationIcons'

/** "Get overall portfolio guidance from experts" rows for the Allocation timer shell. */
export const ALLOCATION_FEATURE_ROWS = [
  {
    iconId: 'portfolioOptimisation360' as const satisfies PlanEducationIconId,
    title: '360° portfolio optimisation',
    caption: 'across allocation, returns, risk and more'
  },
  {
    iconId: 'expertPersonalisedPlan' as const satisfies PlanEducationIconId,
    title: 'Expert-built personalised plan',
    caption: 'for your life stage and risk appetite'
  },
  {
    iconId: 'longTermJourney' as const satisfies PlanEducationIconId,
    title: 'Built for the long-term journey',
    caption: 'to adapt as your needs evolve'
  }
] as const
